<template>
  <PageWrapper
    :active-section="SECTION_MONETIZATION"
    :active-page="PAGE_MONETIZATION_MY_BRANDS"
    title="My Brands"
    page-name="My Brands"
    :breadcrumbs="breadcrumbs"
    align="center"
    width="full"
  >
    <SmartFeed
      :pinia-store="useMyFavoriteAdvertiserCollectionItemFeedStore"
      default-smart-feed-layout="grid"
      default-entity-layout="cardLarge"
    >
      <template #empty-state>
        <iParagraph
          variant="subtle"
          :max-width="800"
        >
          <iRow gap="extraSmall">
            Browse advertisers in the <iLink variant="subtle" href="/community/directory/advertisers" target="_blank">
              creator community
            </iLink> to find and save brands you love
          </iRow>
        </iParagraph>
      </template>
    </Smartfeed>
  </Pagewrapper>
</template>
<script>
import PageWrapper from "@/components/PageWrapper";
import SmartFeed from "SmartFeed/components/SmartFeed";
import {
  PAGE_MONETIZATION_MY_BRANDS,
  SECTION_MONETIZATION,
} from "@/constants/nav-constants";
import {
  useMyFavoriteAdvertiserCollectionItemFeedStore,
} from "SmartFeed/stores/feed/my-favorite-advertiser-collection-item-feed-store";
import { mapState } from "pinia";
import { useAffiliateLinkStore } from "%/stores/affiliate-link-store";

export default {
  name: "MyBrands",
  components: {
    PageWrapper,
    SmartFeed,
  },
  data() {
    return {
      PAGE_MONETIZATION_MY_BRANDS,
      SECTION_MONETIZATION,
    };
  },
  computed: {
    ...mapState(useAffiliateLinkStore, [
      "orgId",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/monetization/org/${this.orgId}`, label: "Monetization" },
      ];
    },
  },
  methods: {
    useMyFavoriteAdvertiserCollectionItemFeedStore,
  },
};
</script>
